import { useTranslation } from '@mint-lib/i18n';
import { Delete } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

export const DiscardButton = ({
  onDiscard,
  disabled,
}: {
  onDiscard: () => void;
  disabled?: boolean;
}) => {
  const { t } = useTranslation('@myn/import-hub');

  return (
    <Button
      onClick={onDiscard}
      disabled={disabled}
      variant="contained"
      color="primary"
      data-dd-action-name="Discard"
    >
      <Delete />
      {t('Discard')}
    </Button>
  );
};
